import { render, staticRenderFns } from "./SatinAlmaGecmisi.vue?vue&type=template&id=17fad8fa&"
import script from "./SatinAlmaGecmisi.vue?vue&type=script&lang=js&"
export * from "./SatinAlmaGecmisi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports